export const AllocationKeySeparator = '--';

export function createAllocationKey(productUuid: string, guestUuid: string): string {
  return `${productUuid}${AllocationKeySeparator}${guestUuid}`;
}

export function parseAllocationKey(key: string): { breakdownItemUuid: string; guestUuid: string } {
  const idx = key.lastIndexOf(AllocationKeySeparator);
  return {
    breakdownItemUuid: key.slice(0, idx),
    guestUuid: key.slice(idx + AllocationKeySeparator.length),
  };
}